import React, { useEffect } from "react";
import classes from "./ProfileComponents.module.scss";
import { useFormContext, Controller } from "react-hook-form";
import WarningTooltip from "./WarningTooltip";
import ImageUploader from "./fields/ImageUploader";
import FileUploader from "./fields/FileUploader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';


const Files = ({
  isEditMode,
  currenciesList,
  onFormReset,
  shouldReset,
  entityInfo,
  profileData,
}) => {
  const { t } = useTranslation();
  const {
    register,
    reset,
    formState: { errors },
    setValue,
    control,
  } = useFormContext();

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  return (
    <>
      <h3 className={classes.subtitle}>
        Additional
        {/* <OverlayTrigger placement="top" overlay={<Tooltip>{t("Information displayed on an invoice")}</Tooltip>}>
          <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
        </OverlayTrigger> */}
      </h3>
      <div className={classes.container}>
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="LegalStructure">{t("Legal structure")}</label>
          <Controller
            name="LegalStructure"
            id="LegalStructure"
            control={control}
            render={({ field }) => {
              return (
                <select {...field} onChange={(e) =>{
                  field.onChange(e);
                }}>
                  <option value="" key=""></option>
                  {entityInfo?.tables[0]._fields?.LegalStructure?._validValues.map((val) => {
                    return <option value={val.Title} key={val.Title}>{t(val.Title)}</option>
                  })}
                  {/* <option value="Subsidary" key="Subsidary">{t("Subsidary")}</option>
                  <option value="Headquater" key="Headquater">{t("Headquater")}</option>
                  <option value="BranchOffice" key="BranchOffice">{t("Branch Office")}</option> */}
                </select>
              );
            }}
          />
          <p className={classes.error}>{errors.LegalEntity?.message}</p>
      </fieldset>
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="CurrencyCode">{t("Currency Code")}</label>
          <Controller
            name="CurrencyCode"
            id="CurrencyCode"
            control={control}
            render={({ field }) => {
              return (
                <select {...field} onChange={(e) =>{
                  field.onChange(e);
                }}>
                  {currenciesList.map((currency) => {
                    return (
                      <option
                        value={currency.Char3CurrencyCode}
                        key={currency.Char3CurrencyCode}
                      >
                        {currency.Char3CurrencyCode}
                      </option>
                    );
                  })}
                </select>
              );
            }}
          />
          <p className={classes.error}>{errors.CurrencyCode?.message}</p>
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="branchName">
          {t("Branch Name")}
            {errors.branchName && <>
              <WarningTooltip text={errors.branchName?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="branchName"
            id="branchName"
            style={errors.branchName ? {outlineColor:"red"}: {}}
            {...register("branchName")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="branchNum">
          {t("Branch Number")}
            {errors.branchNum && <>
              <WarningTooltip text={errors.branchNum?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="branchNum"
            id="branchNum"
            style={errors.branchNum ? {outlineColor:"red"}: {}}
            {...register("branchNum")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="taxOfficeName">
          {t("Tax Office Name")}
            {errors.taxOfficeName && <>
              <WarningTooltip text={errors.taxOfficeName?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="taxOfficeName"
            id="taxOfficeName"
            style={errors.taxOfficeName ? {outlineColor:"red"}: {}}
            {...register("taxOfficeName")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="taxOfficeId">
          {t("Tax Office ID")}
            {errors.taxOfficeId && <>
              <WarningTooltip text={errors.taxOfficeId?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="taxOfficeId"
            id="taxOfficeId"
            style={errors.taxOfficeId ? {outlineColor:"red"}: {}}
            {...register("taxOfficeId")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="IndustryCode">
          {t("Industry code")}
            {errors.taxOfficeName && <>
              <WarningTooltip text={errors.taxOfficeName?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="IndustryCode"
            id="IndustryCode"
            style={errors.IndustryCode ? {outlineColor:"red"}: {}}
            {...register("IndustryCode")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BusinessType">
          {t("Business type")}
            {errors.BusinessType && <>
              <WarningTooltip text={errors.BusinessType?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="BusinessType"
            id="BusinessType"
            style={errors.BusinessType ? {outlineColor:"red"}: {}}
            {...register("BusinessType")}
          />
        </fieldset>
        {/* <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="Telephone">{t("Telephone")}
          {errors.Telephone && <>
              <WarningTooltip text={errors.Telephone?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="Telephone"
            id="Telephone"
            style={errors.Telephone ? {outlineColor:"red"}: {}}
            {...register("Telephone")}
            placeholder={t("Telephone number")}
          />
        </fieldset>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="Email">{t("Email")}
          {errors.Email && <>
              <WarningTooltip text={errors.Email?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="Email"
            id="Email"
            style={errors.Email ? {outlineColor:"red"}: {}}
            {...register("Email")}
            placeholder="example@email.com"
          />
        </fieldset>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BBAN">{t("Website")}
          {errors.Web && <>
              <WarningTooltip text={errors.Web?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="Web"
            id="Web"
            style={errors.Web ? {outlineColor:"red"}: {}}
            {...register("Web")}
            placeholder={t("Website url")}
          />
        </fieldset> */}
      </div>
      {/* <div className={classes.container}>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="Logo">{t("Logo")}
          {errors.Logo && <>
              <WarningTooltip text={errors.Logo?.message}/>
              
            </>}</label>
          <ImageUploader name={"Logo"}
                    register={register}
                    setValue={setValue}
                    control={control}
                    inEditMode = {isEditMode}/>
        </fieldset>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="Logo">{t("Stamp")}
          {errors.Stamp && <>
              <WarningTooltip text={errors.Stamp?.message}/>
              
            </>}</label>
          <ImageUploader name={"Stamp"}
                    register={register}
                    setValue={setValue}
                    control={control}
                    inEditMode = {isEditMode}/>
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BBAN">{t("Website")}
          {errors.Web && <>
              <WarningTooltip text={errors.Web?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="Web"
            id="Web"
            style={errors.Web ? {outlineColor:"red"}: {}}
            {...register("Web")}
            placeholder={t("Website url")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BBAN">{t("Signer")}
          {errors.Signer && <>
              <WarningTooltip text={errors.Signer?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="Signer"
            id="Signer"
            style={errors.Signer ? {outlineColor:"red"}: {}}
            {...register("Signer")}
            placeholder={t("Signer")}
          />
        </fieldset>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="Logo">{t("Signiture scan")}
          {errors.SignScan && <>
              <WarningTooltip text={errors.SignScan?.message}/>
              
            </>}</label>
          <FileUploader name={"SignScan"}
                    register={register}
                    setValue={setValue}
                    control={control}
                    inEditMode = {isEditMode}/>
        </fieldset>
      </div> */}
    </>
  );
};

export default Files;
